import React from "react";

import { Icon } from "components/Icon";
import { useModalStackContext } from "components/base/useModalStack";
import * as S from "./styled";


import { Input, SelectPicker, Uploader } from "rsuite";

const TextArea = React.forwardRef((props, ref) => (
    <Input {...props} as="textarea" ref={ref} />
));

TextArea.displayName = "TextArea";

export const ModalSelectPicker = React.forwardRef(({ menuStyle, ...props }, ref) => {
    const { zIndex } = useModalStackContext();

    return <SelectPicker
        ref={ref}
        menuStyle={{ ...menuStyle, zIndex: zIndex + 5 }}
        {...props}
    />;
});

ModalSelectPicker.displayName = "ModalSelectPicker";

export const FieldInput = ({ name, label, type, componentClass, rows = 4, ...props }) => (
    <S.Group>
        <S.LabelWrapper>
            <S.Label>{label}</S.Label>
        </S.LabelWrapper>
        <S.Field
            name={name}
            {...(componentClass === "textarea" ? { accepter: TextArea, rows } : {})}
            {...props}
        />
    </S.Group>
);

export const FieldFile = ({ name, label, type, defaultFileList, ...props }) => (
    <S.Group>
        <S.LabelWrapper
            vAlign="flex-start"
            top={18}
        >
            <S.Label>{label}</S.Label>
        </S.LabelWrapper>

        <S.FileUploader
            name={name}
            defaultFileList={defaultFileList || []}
            accepter={Uploader}
            {...props}
        >
            <button><Icon icon="file-image-o" size="2x" /></button>
        </S.FileUploader>
    </S.Group>
);

export const FieldSelect = ({ name, label, type, data, valueKey, labelKey, showBadge = false, badgeContent = "", badgeBody = "", ...props }) => (
    <S.Group>
        {label &&
            <S.LabelWrapper>
                <S.Label>{label}</S.Label>
            </S.LabelWrapper>
        }
        <S.Field
            name={name}
            accepter={ModalSelectPicker}
            cleanable={false}
            data={data}
            valueKey={valueKey}
            labelKey={labelKey}
            {...props}
        />
        {showBadge && <S.BadgeInfo content={badgeContent}>{badgeBody}</S.BadgeInfo>}
    </S.Group>
);
